import * as React from "react";
import { Text } from "@uikit";

import { hotelTypeMappping } from "@kalabo/golfsavers-common";
import LikeShare from "@components/common/likeShare";
import { Hotel } from "@kalabo/golfsavers-common";
import { useBreakpoint } from "use-breakpoint";
import { BREAKPOINTS } from "@utilities/constants";
import { FaMapMarkerAlt } from "@react-icons/all-files/fa/FaMapMarkerAlt";
import StarRating from "@components/starRating";

interface IProps {
  hotel: Hotel;
  region: any;
  country: any;
  onShowMap: () => void;
}

const HotelTitle = ({ hotel, region, country, onShowMap }: IProps) => {
  const { breakpoint } = useBreakpoint(BREAKPOINTS, "mobile");

  return (
    <div className="mt-5 sm:mt-0 mb-5 sm:mb-6">
      <div className="grid grid-cols-12">
        <div className="col-span-12 sm:col-span-12">
          <div className="flex items-center mb-[5px] justify-between">
            <div className="flex overflow-hidden">
              <Text
                size={25}
                sizeTablet={30}
                sizeDesktop={35}
                weight="semibold"
                element="h1"
                leading={1.2}
                className="text-ellipsis overflow-hidden w-full whitespace-nowrap"
              >
                {hotel.name.en}
              </Text>
            </div>
            <div className="hidden sm:block">
              <LikeShare value={hotel?.slug} name={hotel?.name?.en} />
            </div>
          </div>
          <div className="flex flex-row md:items-center">
            <div className="flex items-center">
              <StarRating
                hideEmpty
                color="green"
                rating={hotel.star_rating}
                size="medium"
                hideCount
              />
              {breakpoint === "mobile" ? (
                <>
                  <div className=" bg-grey3 h-[18px] w-[1px] mx-2 border-grey2"></div>
                  <Text
                    sizeTablet={15}
                    size={13}
                    className="block"
                    color="black80"
                  >
                    <div className="flex gap-1 items-center">
                      <FaMapMarkerAlt className="w-4 h-4 text-grey6" />
                      <span>{hotel.area?.name?.en}</span>
                    </div>
                  </Text>
                </>
              ) : (
                <>
                  <div className=" bg-grey3 h-[18px] w-[1px] mx-2 border-grey2"></div>
                  <Text size={15} color="black80" className="ml-1">
                    {hotel.star_rating}-star{" "}
                    {hotelTypeMappping(hotel?.hotel_type).toLowerCase()} in{" "}
                    {region.name.en}, {country.name.en} ·
                  </Text>
                  <span
                    onClick={() => {
                      onShowMap();
                    }}
                    className="hidden sm:inline"
                  >
                    <Text
                      size={15}
                      color="black90"
                      weight="semibold"
                      className="ml-1 underline cursor-pointer hover:text-blue"
                    >
                      View on map
                    </Text>
                  </span>
                </>
              )}
            </div>
            {hotel.is_recommended && (
              <div className="self-center bg-darkorange pt-[2px] pb-[2px] px-[6px]  sm:hidden rounded-[2px]  ml-[10px]">
                <Text
                  size={12}
                  weight="semibold"
                  leading={1.3}
                  color="white"
                  className="uppercase"
                >
                  Recommended
                </Text>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelTitle;
